<script setup>
import { onMounted } from "vue";

const props = defineProps({
  label: String,
  disabled: Boolean,
});
</script>

<template>
  <button
    class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded-sm"
    :class="{ 'opacity-50 cursor-not-allowed': disabled }"
    :disabled="props.disabled"
  >
    {{ props.label }}
    <slot />
  </button>
</template>
